module.exports = __webpack_public_path__ + "media/images/application/template/30-second-quote/4x2-flatpack-b036f480306df0520661df8f2ed4eb35.png";